import type { PageCard } from '@/play/pageTypes'
import { GhostLettersCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'ghost-letters',
  number: 20,
  title: 'Ghost letters',
  question: 'Can a child see the order and direction of a letter\'s strokes from a ghost drawing of it?',
  status: 'open',
  accent: '#dbe6fb',
  CardArt: GhostLettersCardArt,
}
